import { useSyncExternalStore } from 'react';
import accessLocalStorage, { subscribeIsOrgLevel } from 'services/localStorage';

const subscribe = (onStoreChange: () => void): (() => void) => {
  const unsubscribe = subscribeIsOrgLevel(onStoreChange);
  window.addEventListener('storage', onStoreChange);

  return () => {
    unsubscribe();
    window.removeEventListener('storage', onStoreChange);
  };
};

const getSnapshot = (): boolean => accessLocalStorage.getIsOrgLevel();

/**
 * Custom hook to get and monitor the org-level view state
 * @returns {boolean} isOrgLevel - true if viewing at organization level, false for store level
 *
 * @example
 * ```tsx
 * const MyComponent = () => {
 *   const isOrgLevel = useOrgLevel();
 *
 *   return (
 *     <div>
 *       {isOrgLevel ? (
 *         <OrgLevelView />
 *       ) : (
 *         <StoreLevelView />
 *       )}
 *     </div>
 *   );
 * };
 * ```
 */
export const useOrgLevel = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

export default useOrgLevel;
